export function existsTournament(data, sportId, categoryId, tournamentId) {
    const uniqueId = `${sportId}_${categoryId}_${tournamentId}`;
    return data?.tournamentByUniqueId?.[uniqueId];
}
